import { ProductListAPIResponse } from "../models/productlistresponse.model";
import { ProductAPIResponse } from "../models/productresponse.model";
export interface IProductState {
  Products: ProductListAPIResponse;
  AllProducts: ProductListAPIResponse;
  Product: ProductAPIResponse;
}

export const initialProductState: IProductState = {
  Products: null,
  AllProducts: null,
  Product: null,
};
